module.exports = __webpack_public_path__ + "00a7d7e01f17fc5e53d6b6e643b54bde.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/payment-request.svg
// module id = 2272
// module chunks = 0 1